import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const dMIspApi = createApi({
  reducerPath: 'dMIspApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['ISP'],
  endpoints: builder => ({
    getIsps: builder.query({
      query: (params) => ({
        url: `/domains/isps/`,
        params,
      }),
      providesTags: ['ISP']
    }),

    createIsp: builder.mutation({
      query: data => ({
        url: '/domains/isps/',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['ISP']
    }),
    getIspById: builder.query({
      query: ({ id, relations }) => ({
        url: `/domains/isps/${id}/`,
        method: 'GET',
        params: { relations }
      }),
      providesTags: ['ISP']
    }),
    updateIsp: builder.mutation({
      query: ({ id, body }) => ({
        url: `/domains/isps/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ISP']
    }),

    deleteIsp: builder.mutation({
      query: id => ({
        url: `/domains/isps/${id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ['ISP']
    })
  })
})

export const {
  useGetIspsQuery,
  useLazyGetIspsQuery,
  useGetIspByIdQuery,
  useCreateIspMutation,
  useUpdateIspMutation,
  useDeleteIspMutation
} = dMIspApi
